import styled from 'styled-components';
import { H1 } from 'styles/FontStyles';

interface ButtonProps {
  topLeft?: string;
  left?: string;
  right?: string;
  active?: boolean;
}

export const AuthButton = styled.button<ButtonProps>`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border-top-left-radius: ${({ left }) => (left ? left : 0)};
  border-bottom-left-radius: ${({ left }) => (left ? left : 0)};
  border-top-right-radius: ${({ right }) => (right ? right : 0)};
  border-bottom-right-radius: ${({ right }) => (right ? right : 0)};
  background: ${({ active, theme }) =>
    active ? theme.primary : 'rgba(91, 92, 134, 0.25)'};
  color: ${({ theme }) => theme.white};
  border: none;
`;

export const FormTitle = styled(H1)`
  text-align: center;
  margin: 40px 0 15px 0;
  background: linear-gradient(
    226.18deg,
    #ffb084 -1.71%,
    #f02b00 48.95%,
    #ffffff 101.34%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const StrengthBar = styled.div`
  background: ${(props) => props.color};
  height: 6px;
  width: 22%;
  text-align: center;
  border-radius: 50px;
`;

export const StrengthText = styled.p`
  font-size: 12px;
  margin-top: 12px;
  color: ${(props) => props.color};
`;

export const TermsAndCondition = styled.ul`
  li {
    color: #5a5a5a;
    font-size: 16px;
    line-height: 24px;
    margin-top: 20px;
  }
`;
